import { STORAGE_SESSION_ACTIVE } from "../constants"
import { SYSTEM_LOGIN } from "../routes"
import { deleteStorageVariable } from "./storage"

export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const response = await fetch(url, {
    ...options,
    credentials: "include",
  })

  if (response.status === 401) {
    deleteStorageVariable(STORAGE_SESSION_ACTIVE)
    window.location.href = SYSTEM_LOGIN
  }

  return response
}
